import { render, staticRenderFns } from "./FaceLive.vue?vue&type=template&id=5e1924d6&scoped=true&"
import script from "./FaceLive.vue?vue&type=script&lang=js&"
export * from "./FaceLive.vue?vue&type=script&lang=js&"
import style0 from "./FaceLive.vue?vue&type=style&index=0&id=5e1924d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1924d6",
  null
  
)

component.options.__file = "FaceLive.vue"
export default component.exports